import script from "./common-list-page.vue?vue&type=script&setup=true&lang=js"
export * from "./common-list-page.vue?vue&type=script&setup=true&lang=js"

import "./common-list-page.vue?vue&type=style&index=0&id=60055ad5&scoped=true&lang=scss"

import exportComponent from "/Users/wen/projects/chun-qiu-museum/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60055ad5"]])

export default __exports__